<script setup lang="ts">
import { computed, ref } from 'vue';
import Checkbox from 'primevue/checkbox';
import Fluid from 'primevue/fluid';
import InputTextAera from 'primevue/textarea';
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';

interface Props {
  optionAir: any;
  isAvancedForm: boolean;
  isFlight?: boolean;
  isShowError: boolean;
  errorMessage?: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:optionAir': [value: any];
  'update:isAvancedForm': [value: boolean];
  'update:isFlight': [value: boolean];
  'update:isShowError': [value: boolean];
  'update:errorMessage': [value: string];
}>();

const option = computed({
  get() {
    return props.optionAir;
  },
  set(value) {
    emits('update:optionAir', value);
  }
});

const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const classOfService = ref([{ type: 'Economy' }, { type: 'Premium' }, { type: 'Business' }, { type: 'First' }]);
</script>
<template>
  <div class="air-additonal-form">
    <Fluid v-if="!isAvancedForm && !isFlight">
      <div class="field">
        <label for="service">{{ $t('create_quote.class_of_service') }}</label>
        <Select id="service" v-model="option.service" :options="classOfService" :placeholder="$t('create_quote.class_of_service')" option-label="type" :class="isShowError && errorMessage ? 'p-invalid' : ''" />
        <span class="text-red-500" v-if="isShowError">
          {{ errorMessage }}
        </span>
      </div>
    </Fluid>
    <Fluid v-if="isAvancedForm && !isFlight">
      <div class="field" v-if="false">
        <label for="dest">{{ $t('create_quote.class_of_service') }}</label>
        <MultiSelect v-model="option.service" :options="classOfService" optionLabel="type" :placeholder="$t('create_quote.class_of_service')" display="chip" :class="isShowError && errorMessage ? 'p-invalid w-full mt-2' : 'w-full mt-2'" />
        <span class="text-red-500" v-if="isShowError">
          {{ errorMessage }}
        </span>
      </div>
    </Fluid>

    <Fluid v-if="!isFlight">
      <div class="field">
        <label for="directFlight">{{ $t('create_quote.direct_flight') }}</label>
        <div>
          <Checkbox id="flightCheckbox" v-model="option.directFlight" :binary="true" />
          <label class="ml-1" for="direct">{{ $t('common.yes') }}</label>
        </div>
      </div>
    </Fluid>
    <Fluid v-if="authorizations?.advance_quote?.additional_note_view">
      <div class="field flex-col">
        <label for="additionalNote">{{ $t('advance_quote.form.additional_note') }}</label>
        <InputTextAera v-model="option.additionalNote" class="additional-area not-resize" :autoResize="true" rows="5" cols="30" maxlength="500" />
      </div>
    </Fluid>
  </div>
</template>
